import {ApiResponse} from '../CommonInterfaces';
import {
  FilterOptionsForWarehouseResponse,
  GetShipmentItemsResponse,
  GetShipmentsParams,
  RemoveLpnFromShipmentRequest,
  RemoveLpnFromShipmentResponse,
  ReplaceLpnsOnShipmentRequest,
  ReplaceLpnsOnShipmentResponse,
  SetShipmentShipOnTimeReasonCodeResponse,
  Shipment,
  ShipmentDetailsInterface,
  ShipmentOverageResponse,
  ShipmentResponse,
  UpdateShipmentRequest
} from '../../warehouse/outbound-shipments/ShipmentInterfaces';
import InternalAPIService from './InternalAPIService';

class OutboundShipmentService extends InternalAPIService {
  constructor(authenticityToken: string) {
    super(authenticityToken, '');
  }

  public async getShipmentsDeprecated(params: GetShipmentsParams): Promise<ApiResponse<ShipmentResponse>> {
    return await this.makeGetRequest('/api/v2/outbound/shipments', params);
  }

  public async shipmentDetailsDeprecated(shipmentId: number): Promise<ApiResponse<ShipmentDetailsInterface>> {
    return await this.makeGetRequest(`/api/v2/outbound/shipments/${shipmentId}`);
  }

  public async getShipmentItems(
    shipmentId: number,
    continuationToken: string
  ): Promise<ApiResponse<GetShipmentItemsResponse>> {
    return await this.makeGetRequest(`/api/v2/shipments/${shipmentId}/items`, {
      'continuation-token': continuationToken
    });
  }

  public async updateShipment(request: UpdateShipmentRequest): Promise<ApiResponse<Shipment>> {
    return await this.makePatchRequest(`/api/v2/outbound/shipments/${request.shipmentId}`, {
      num_pallets_built: request.numPalletsBuilt,
      notes: request.notes
    });
  }

  public async ship(shipmentId: number): Promise<ApiResponse<Shipment>> {
    return await this.makePostRequest(`/api/v2/outbound/shipments/${shipmentId}/ship`, {});
  }

  public async removeLpnFromShipment(
    request: RemoveLpnFromShipmentRequest
  ): Promise<ApiResponse<RemoveLpnFromShipmentResponse>> {
    return await this.makeDeleteRequest(
      `/api/v2/outbound/shipments/${request.shipmentId}/lpns?lpn_barcode=${encodeURIComponent(request.lpnBarcode)}`
    );
  }

  public async replaceLpnsOnShipment(
    request: ReplaceLpnsOnShipmentRequest
  ): Promise<ApiResponse<ReplaceLpnsOnShipmentResponse>> {
    return await this.makePutRequest(`/api/v2/outbound/shipments/${request.shipmentId}/lpns`, {
      lpn_id_to_remove: request.lpnIdToRemove,
      lpn_id_to_add: request.lpnIdToAdd
    });
  }

  public async calculateOverages(shipmentId: number): Promise<ApiResponse<ShipmentOverageResponse>> {
    return await this.makeGetRequest(`/api/v2/outbound/shipments/${shipmentId}/overages`);
  }

  public async filterOptionsForWarehouse(warehouseId: number): Promise<ApiResponse<FilterOptionsForWarehouseResponse>> {
    return await this.makeGetRequest(`/api/v2/warehouse_shipments/filter_options?warehouseId=${warehouseId}`);
  }

  public async setMissedSlaReasonCode(
    shipmentIds: number[],
    reasonCode: string
  ): Promise<ApiResponse<SetShipmentShipOnTimeReasonCodeResponse>> {
    return (await this.makePostRequest(`/api/v2/outbound/shipments/set_missed_sla_reason_code`, {
      shipment_ids: shipmentIds,
      reason_code: reasonCode
    })) as ApiResponse<SetShipmentShipOnTimeReasonCodeResponse>;
  }
}

export default OutboundShipmentService;
